module.exports = __webpack_public_path__ + "icon_grade-1f9e039d0f024626ab071d18098b65a0.png";